<template>
  <form v-if="!isLoading" @submit.prevent="onSubmit">
    <div class="row">
      <div class="col-12">
        <b-checkbox v-model="question.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <app-input
          v-model="question.title"
          label="Pergunta"
          :errors="errors.title"
          required
        ></app-input>
      </div>
      <div class="col-3">
        <b-field label="Resposta Correta" required>
          <b-select v-model="question.correct" placeholder="Selecionar">
            <option
              v-for="(option, index) in correctOptions"
              :key="index"
              :value="(index + 1)"
              >{{ option }}</option
            >
          </b-select>
        </b-field>
        <div v-if="errors.correct" class="input-error">
          {{ errors.correct }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <b-field label="A)">
          <b-input
            v-model="question.answer_1"
            maxlength="256"
            type="textarea"
          ></b-input>
        </b-field>
      </div>
      <div class="col-6">
        <b-field label="B)">
          <b-input
            v-model="question.answer_2"
            maxlength="256"
            type="textarea"
          ></b-input>
        </b-field>
      </div>
      <div class="col-6">
        <b-field label="C)">
          <b-input
            v-model="question.answer_3"
            maxlength="256"
            type="textarea"
          ></b-input>
        </b-field>
      </div>
      <div class="col-6">
        <b-field label="D)">
          <b-input
            v-model="question.answer_4"
            maxlength="256"
            type="textarea"
          ></b-input>
        </b-field>
      </div>
      <div class="col-6">
        <b-field label="E)">
          <b-input
            v-model="question.answer_5"
            maxlength="256"
            type="textarea"
          ></b-input>
        </b-field>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import TrainingQuestionService from '@/services/training-question.service';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'training-questions-form',
  props: ['id', 'errors', 'saving'],
  data: () => {
    return {
      isLoading: true,
      options: ['A', 'B', 'C', 'D', 'E'],
      question: {
        active: true,
        title: null,
        correct: null,
        answer_1: null,
        answer_2: null,
        answer_3: null,
        answer_4: null,
        answer_5: null,
      },
    };
  },
  computed: {
    correctOptions() {
      return this.options.filter((option, index) => {
        return !!this.question[`answer_${index + 1}`];
      });
    },
  },
  validations: {
    question: {
      title: { required },
      correct: { required },
    },
  },
  methods: {
    loadQuestion(id) {
      TrainingQuestionService.getId(id)
        .then(({ data: question }) => (this.question = question))
        .catch(() => this.toastify('Erro ao carregar pergunta.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onSubmit() {
      this.$emit('submit', this.question);
    },
  },
  watch: {
    correctOptions() {
      if (!this.question[`answer_${this.question.correct}`])
        this.question.correct = null;
    },
  },
  beforeMount() {
    if (this.id) this.loadQuestion(this.id);
    else this.isLoading = false;
  },
};
</script>
